import { __assign } from "tslib";
import React from 'react';
import SimpleThread from '../SimpleThread';
import { COMMENT_MODAL_THREAD_MAX_DEPTH } from '../../constants';
import s from './ModalThread.scss';
var ModalThread = function (props) {
    return (React.createElement(SimpleThread, __assign({}, props, { scrollableClassName: s['scrollable'], commentClassName: s['comment'], commentWrapperClassName: s['comment-wrapper'], viewRepliesClassName: s['view-replies-wrapper'], maxDepthOverride: COMMENT_MODAL_THREAD_MAX_DEPTH, replyIndentModifier: 1 })));
};
ModalThread.displayName = 'ModalThread';
export default ModalThread;
//# sourceMappingURL=ModalThread.js.map